export default "__VITE_ASSET__BXOz7j24__"